import fetchClient from './fetchClient';
import { errorHandler } from "./utils";


const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const updatePlugin = async (plugin: string, data: any) => {
    const res: any = await fetchClient
        .put(`/plugins/${plugin}`, data, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getPlugin = async (plugin: string) => {
    const res: any = await fetchClient
        .get(`/plugins/${plugin}`, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getPublicCrispConfig = async (ownerId: string) => {
    const res: any = await fetchClient
        .get(`/plugins/crisp/public/${ownerId}`)
        .catch(errorHandler);

    if (!res) return null;
    return res.data;
};